











import { defineComponent, ref, computed } from '@vue/composition-api';
import store from '@/renderer/store';

import AgreementJump from './AgreementJump.vue';

export interface AgreementComponent {
  $el: HTMLElement;
  approved: boolean;
  validate: () => boolean;
}

export default defineComponent({
  name: 'AgreementCheckbox',
  components: { AgreementJump },
  props: {
    placement: {
      type: String,
      default: 'top-left',
    },
  },
  setup(props, { emit }) {
    const showAgreementPopup = ref(false);
    const approved = computed({
      get() {
        return store.getters.approvedAgreement;
      },
      set(val: boolean) {
        store.commit('SET_APPROVED_AGREEMENT', val);
      },
    });

    const methods = {
      changeApprove(val: boolean) {
        showAgreementPopup.value = false;
        emit('change', val);
      },
      validate() {
        if (!approved.value) {
          showAgreementPopup.value = true;
        }
        return approved.value;
      },
      closePopup(e?: HTMLElement) {
        let target = e;
        if (e?.className === '' && e?.firstChild) {
          target = e.firstChild as HTMLElement;
        }
        // 点击更多登录方式的图标（除访客登录icon）不关闭popup
        const clickMoreEntranceIcon = target?.className?.includes?.('smh-icon--28') || false;
        const clickVisitorIcon = target?.className?.includes?.('vistor-icon') || false;
        if (clickMoreEntranceIcon && !clickVisitorIcon) return;

        showAgreementPopup.value = false;
      },
    };

    return {
      approved,
      showAgreementPopup,
      ...methods,
    };
  },
});
